function ManageArea(props: any) {
  let myProps = {
    delete_by_ajax: (inData: any) => { },
    open_write_popup: (inData: any) => { },
    ...props
  };

  return (
    <div className="my_flex_center">
      <button className="btn btn-sky" 
        onClick={()=>{
          myProps.open_write_popup({});
        }}>수정</button>
      <button className="btn btn-red"
        onClick={() => {
          myProps.delete_by_ajax();
        }} >삭제</button>
    </div>
  );
};
export default ManageArea;